<template>
  <div>
    <b-row
      class="content-header"
    >

      <!-- Content Left -->
      <b-col
        class="content-header-left mb-2"
        cols="12"
        md="9"
      >
        <b-row class="breadcrumbs-top">
          <b-col cols="12">
            <h1 class="custom-header-title">
              {{ area.stringID }} - {{ area.name }}
            </h1>
            <p class="log_info">
              Created by {{ area.createdBy ? area.createdBy.name : '' }} on {{ dateFormatWithTime(area.createdAt) }} <br>Last updated on {{ dateFormatWithTime(area.updatedAt) }}
            </p>
          </b-col>
        </b-row>
      </b-col>

      <b-col
        class="content-header-right text-md-right d-md-block d-none mb-1"
        md="3"
        cols="12"
      >
        <div class="user_block pr_stage_type">
          <div class="user_avatar" />
          <div class="user_info">
            <h6>Status</h6>
            <h5 :class="`text-${resolveStatusVariant(area.status)}`">
              {{ area.status }}
            </h5>
          </div>
          <div class="action_button">
            <b-button
              v-b-modal.modal-update-status
              variant="flat-primary"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="12">
        <b-card
          header-tag="header"
          class=""
        >
          <div class="d-flex justify-content-between">
            <b-table-simple
              borderless
              responsive
              class="custom-th-width"
            >
              <b-tbody>
                <b-tr>
                  <b-th width="230">
                    Area Name
                  </b-th>
                  <b-td class="mt-50">
                    {{ area.name || '-' }}
                  </b-td>
                </b-tr>
                <b-tr>
                  <b-th width="230">
                    SCLC API Endpoint for Lots and Reservations
                  </b-th>
                  <b-td class="mt-50">
                    {{ area.sclcApiEndpoint || '-' }}
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
            <b-button
              variant="flat-primary"
              class="display-content"
              :to="{ name: 'products-areas-edit', params: { id: $route.params.id } }"
            >
              <feather-icon
                icon="EditIcon"
                class="mr-50"
                size="16"
              />
              <span class="align-middle">Edit</span>
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      id="modal-update-status"
      ref="update-status-modal"
      cancel-variant="flat-primary"
      ok-variant="success"
      ok-title="Update"
      cancel-title="Cancel"
      centered
      no-close-on-backdrop
      title="Update Status"
      @ok="submitForm"
    >
      <b-form @submit.prevent="submitForm">
        <validation-observer
          ref="areaStatusEditForm"
        >
          <b-form-group
            label="Status*"
            label-for="h-activity-type-status"
          >
            <validation-provider
              #default="{ errors }"
              name="Status"
              vid="status"
              rules="required"
            >
              <v-select
                id="h-activity-type-status"
                v-model="status"
                label="title"
                :options="statusDataOptions"
                :reduce="title => title.code"
                :clearable="false"
                @input="statusValidation == true ? statusValidation = false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
              <small
                v-if="statusValidation"
                class="text-danger"
              >
                {{ statusError }}
              </small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BButton, BTableSimple, BTbody, BTr, BTd, BTh, BForm, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import store from '@/store/index'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTableSimple,
    BTbody,
    BTh,
    BTr,
    BTd,
    BForm,
    BFormGroup,
    vSelect,

    ValidationProvider,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      area: {},
      status: 'published',
      statusValidation: false,
      statusError: 'Valid status is required',
      statusDataOptions: [
        { title: 'Published', code: 'published' },
        { title: 'Draft', code: 'draft' },
      ],
      required,
    }
  },
  created() {
    this.$http.get(`reservation/suite-area/${this.$route.params.id}`)
      .then(response => {
        this.area = response.data
        this.status = response.data.status

        store.commit('breadcrumb/REMOVE_BREADCRUMB')
        const newMeta = {
          active: true,
          text: this.area.name,
        }
        store.commit('breadcrumb/UPDATE_BREADCRUMB', newMeta)
      })
      .catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.data.message ?? process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  },
  methods: {
    resolveStatusVariant(status) {
      if (status === 'published') return 'success'
      if (status === 'draft') return 'secondary'
      return 'primary'
    },
    submitForm() {
      this.$refs.areaStatusEditForm.validate().then(success => {
        if (success) {
          const formData = new FormData()
          formData.append('status', this.status)

          this.$http.patch(`reservation/suite-area/${this.$route.params.id}/status/update`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then(response => {
              this.area.status = response.data.data.status || 'published'
              this.status = this.area.status

              this.$swal({
                title: 'Status Updated!',
                html: 'The status for this area has been updated',
                // eslint-disable-next-line global-require
                imageUrl: require('@/assets/images/icons/save.png'),
                imageWidth: 80,
                imageHeight: 80,
                imageAlt: 'Custom Icon',
                showCancelButton: false,
                confirmButtonText: 'Okay',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
              })
            })
            .catch(error => {
              if (error.data.errors) {
                error.data.errors.forEach(validationError => {
                  if (validationError.param === 'status') {
                    this.statusError = validationError.msg
                    this.statusValidation = true
                  }
                })
              } else {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                  },
                })
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
  .item-field-custom-class {
    color: #000000;
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
  }
  .display-content {
    display: contents;
  }

  .custom-th-width {
    .table th {
        padding: 0.72rem 2rem 0.72rem 0.72rem;
    }
  }
</style>
